import { render, staticRenderFns } from "./KeyHighlights.vue?vue&type=template&id=0228c549"
import script from "./KeyHighlights.vue?vue&type=script&lang=js"
export * from "./KeyHighlights.vue?vue&type=script&lang=js"
import style0 from "./KeyHighlights.vue?vue&type=style&index=0&id=0228c549&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports